import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { languages, defaultLocale, loadLanguageResources } from "./locale";

const initI18n = async () => {
  try {
    const resources = {};

    // Load language resources dynamically from S3
    for (const [key] of Object.entries(languages)) {
      const data = await loadLanguageResources(key); // Fetch resources dynamically
      if (data) {
        resources[key] = { translations: data };
      }
    }

    i18n.use(initReactI18next).init({
      resources,
      whitelist: Object.keys(languages),
      fallbackLng: defaultLocale,
      debug: false,
      lng: defaultLocale,
      ns: ["translations"],
      defaultNS: "translations",
      keySeparator: false,
      interpolation: {
        escapeValue: false,
        formatSeparator: ",",
      },
    });
  } catch (error) {
    console.error("Error initializing i18n:", error.message);
  }
};

export default initI18n;
